<template>
  <div class="bb-back">
    <div @click="clickAction">
      <img
        class="bbb-img-back"
        src="@/assets/icons/chevron-left-solid -colortext2.svg"
        alt="chevron-left"
      />
      {{ caption }}
    </div>
  </div>
</template>

<script>
export default {
  name: "BackButton",
  props: {
    prevPath: { type: String },
    caption: { type: String },
    clickButton: {
      type: Function,
      default: function () {
        const hasHistory = window.history.length > 2;
        hasHistory ? this.$router.go(-1) : this.$router.push("/");
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    clickAction() {
      if (this.clickButton) {
        this.clickButton();
        return;
      }
    },
  },
};
</script>

<style scoped>
.bb-back {
  color: #acb1bf;
  display: flex;
  align-items: center;
  /* margin-top: 23px;
  margin-bottom: 16px; */
  width: 100%;
}
.bb-back > div {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.bbb-img-back {
  margin-right: 10px;
}
</style>
